<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11mwlaI/tc-custom/9780759515888.jpg?1734320848577" alt="This image is the cover for the book Girls"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Girls
      </h1>
      <p class="bookDescription body article font2">
        <b>A novel of conjoined sisters and the connections, visible or invisible, that cannot be broken: “An unsentimental, heartwarming page-turner” (<i>Kirkus Reviews</i>, starred review).</b><br/><br/>Meet Rose and Ruby: sisters, best friends, confidantes, and conjoined twins. Since their birth, Rose and Ruby Darlen have been known simply as “the girls.” They make friends, fall in love, have jobs, love their parents, and follow their dreams. But the Darlens are special. Now nearing their thirtieth birthday, they are history’s oldest craniopagus twins, joined at the head by a spot the size of a bread plate.<br/><br/>When Rose, the bookish sister, sets out to write her autobiography, it inevitably becomes the story of her short but extraordinary life with Ruby, the beautiful one. From their awkward first steps—Ruby’s arm curled around Rose’s neck, her foreshortened legs wrapped around Rose’s hips—to the friendships they gradually build for themselves in the small town of Leaford, they are on an incomparable life journey.<br/><br/>As Rose and Ruby’s story builds to an unforgettable conclusion, Lori Lansens aims at the heart of human experience—the hardship of loss and struggles for independence, and the fundamental joy of simply living a life. This is a breathtaking novel, one that no reader will soon forget, a heartrending story of love between sisters.<br/><br/>“A stunner . . . laced with delightful comic moments.” —<i>Toronto Star</i><br/><br/>“Utterly compelling.” —<i>Newsday</i><br/><br/>“Love, connection, loyalty, raw humanity and much more are the ingredients of this most unusual novel. Lori Lansens’s blend of tragedy and comedy will touch you deeply.” —Isabel Allende<br/><br/>“Extraordinary.” —<i>Time Magazine</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lori Lansens
      </h2>
      
      <p class="authorDescription body article"><B>Lori Lansens</B> has written several films and is the author of the novel <I>Rush Home Road</I>. <I>The Girls</I> is her second book. She lives in Toronto.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Little Brown & Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4764063e